import { PublishedDocEnvironment } from "../dsm";
import { nullishToOptional } from "../helpers";
import { z } from "zod";
const BITBUCKET_SLUG = /^[-a-zA-Z0-9~]*$/;
const BITBUCKET_MAX_LENGTH = 64;
export const ExportJobDocumentationChanges = z.object({
    pagePersistentIds: z.string().array(),
    groupPersistentIds: z.string().array(),
    selectivePublishing: z.boolean().optional(),
});
export const ExporterDestinationDocs = z.object({
    environment: PublishedDocEnvironment,
    changes: nullishToOptional(ExportJobDocumentationChanges),
});
export const GitCommonDestinationOptions = z.object({
    branch: z.string(),
    relativePath: nullishToOptional(z.string()),
    purgeDirectory: nullishToOptional(z.boolean()),
    commitAuthorName: nullishToOptional(z.string()),
    commitAuthorEmail: nullishToOptional(z.string()),
    commitMessage: nullishToOptional(z.string()),
    commitToBranch: nullishToOptional(z.string()),
    pullRequestTitle: nullishToOptional(z.string()),
    pullRequestDescription: nullishToOptional(z.string()),
    checkoutNoTags: nullishToOptional(z.boolean()),
    checkoutNoBlobs: nullishToOptional(z.boolean()),
    checkoutSparse: nullishToOptional(z.boolean()),
});
export const ExporterDestinationS3 = z.object({});
export const ExporterDestinationGithub = z
    .object({
    credentialId: z.string().optional(),
    // Repository
    url: z.string(),
    // Legacy deprecated fields. Use `credentialId` instead
    connectionId: nullishToOptional(z.string()),
    userId: nullishToOptional(z.number()),
})
    .extend(GitCommonDestinationOptions.shape);
export const ExporterDestinationAzure = z
    .object({
    credentialId: z.string().optional(),
    // Repository
    organizationId: z.string(),
    projectId: z.string(),
    repositoryId: z.string(),
    // Maybe not needed
    url: nullishToOptional(z.string()),
    // Legacy deprecated fields. Use `credentialId` instead
    connectionId: nullishToOptional(z.string()),
    userId: nullishToOptional(z.number()),
})
    .extend(GitCommonDestinationOptions.shape);
export const ExporterDestinationGitlab = z
    .object({
    credentialId: z.string().optional(),
    // Repository
    projectId: z.string(),
    // Maybe not needed
    url: nullishToOptional(z.string()),
    // Legacy deprecated fields. Use `credentialId` instead
    connectionId: nullishToOptional(z.string()),
    userId: nullishToOptional(z.number()),
})
    .extend(GitCommonDestinationOptions.shape);
export const ExporterDestinationBitbucket = z
    .object({
    credentialId: z.string().optional(),
    // Repository
    workspaceSlug: z.string().max(BITBUCKET_MAX_LENGTH).regex(BITBUCKET_SLUG),
    projectKey: z.string().max(BITBUCKET_MAX_LENGTH).regex(BITBUCKET_SLUG),
    repoSlug: z.string().max(BITBUCKET_MAX_LENGTH).regex(BITBUCKET_SLUG),
    url: nullishToOptional(z.string()),
    // Legacy deprecated fields. Use `credentialId` instead
    connectionId: nullishToOptional(z.string()),
    userId: nullishToOptional(z.number()),
})
    .extend(GitCommonDestinationOptions.shape);
export const ExportDestinationsMap = z.object({
    webhookUrl: z.string().optional(),
    destinationSnDocs: ExporterDestinationDocs.optional(),
    destinationS3: ExporterDestinationS3.optional(),
    destinationGithub: ExporterDestinationGithub.optional(),
    destinationAzure: ExporterDestinationAzure.optional(),
    destinationGitlab: ExporterDestinationGitlab.optional(),
    destinationBitbucket: ExporterDestinationBitbucket.optional(),
});
export const ExportDestinationsMapUpdate = z.object({
    webhookUrl: z.string().nullish(),
    destinationSnDocs: ExporterDestinationDocs.nullish(),
    destinationS3: ExporterDestinationS3.nullish(),
    destinationGithub: ExporterDestinationGithub.nullish(),
    destinationAzure: ExporterDestinationAzure.nullish(),
    destinationGitlab: ExporterDestinationGitlab.nullish(),
    destinationBitbucket: ExporterDestinationBitbucket.nullish(),
});
